import { createFileRoute } from '@tanstack/react-router';

import { DmOfferLandingPage } from 'src/apps/checkout/app/pages/DmOffer.Landing';

export const Route = createFileRoute(
  '/_auth/_only-header/store/dm-offer/_allowed/'
)({
  component: () => <DmOfferLandingPage />,
});
